jQuery(function($) {
    'use strict';

    var AppHotels = function() {
    }

    AppHotels.prototype.init = function() {
        $(document).on('click', '.hotel-teaser', function() {
            var teasers = $(this).closest('.hotels-wrapper').find('.hotel-teaser-wrapper').find('.hotel-teaser');
            var slideshow = $('.slideshow-hotels');

            var int = $(this).data('hotelInt');

            slideshow.slick('goTo', int - 1);

            teasers.removeClass('active');
            $(this).addClass('active');
        });
    }

    $.AppHotels = new AppHotels;
    $.AppHotels.Constructor = AppHotels;
});

jQuery(function($) {
    'use strict';

    $.AppHotels.init();
});
